import React, { useEffect, useState } from "react";
import axios from "axios";
const ENV_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

const API = `${ENV_API_BASE_URL}/api/teacher-training-cards`;

function TeacherTrainingCards() {

  const [data, setData] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);

  const [formData, setFormData] = useState({
    number: "",
    slug: "",
    icon: "",
    heading: "",
    paragraph: "",
    image: null,

    benefits: [
      { mainHeading: "", icon: "", cardHeading: "", cardParagraph: "" }
    ],

    traditional: [
      { heading: "", number: "", title: "" }
    ],

    practice: [
      { heading: "", cardicon: "", cardHead: "", cardPara: "" }
    ]
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const res = await axios.get(API);
    setData(res.data.data);
  };

  const handleChange = (e) => {
    if (e.target.name === "image") {
      setFormData({ ...formData, image: e.target.files[0] });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const sendData = new FormData();

    sendData.append("number", formData.number);
    sendData.append("slug", formData.slug);
    sendData.append("icon", formData.icon);
    sendData.append("heading", formData.heading);
    sendData.append("paragraph", formData.paragraph);

    sendData.append("benefits", JSON.stringify(formData.benefits));
    sendData.append("traditional", JSON.stringify(formData.traditional));
    sendData.append("practice", JSON.stringify(formData.practice));

    if (formData.image) {
      sendData.append("image", formData.image);
    }

    if (editId) {
      await axios.put(`${API}/${editId}`, sendData);
    } else {
      await axios.post(API, sendData);
    }

    fetchData();
    setShowForm(false);
    setEditId(null);

    setFormData({
      number: "",
      slug: "",
      icon: "",
      heading: "",
      paragraph: "",
      image: null,
      benefits: [{ mainHeading: "", icon: "", cardHeading: "", cardParagraph: "" }],
      traditional: [{ heading: "", number: "", title: "" }],
      practice: [{ heading: "", cardicon: "", cardHead: "", cardPara: "" }]
    });
  };

  const handleDelete = async (id) => {
    await axios.delete(`${API}/${id}`);
    fetchData();
  };

  const handleEdit = (item) => {
    setFormData({
      number: item.number || "",
      slug: item.slug || "",
      icon: item.icon || "",
      heading: item.heading || "",
      paragraph: item.paragraph || "",
      image: null,
      benefits: item.benefits || [{ mainHeading: "", icon: "", cardHeading: "", cardParagraph: "" }],
      traditional: item.traditional || [{ heading: "", number: "", title: "" }],
      practice: item.practice || [{ heading: "", cardicon: "", cardHead: "", cardPara: "" }]
    });

    setEditId(item._id);
    setShowForm(true);
  };

  return (
    <div className="container pt-5 mt-5">

      {!showForm && (
        <>
          <button
            className="btn btn-primary mb-3"
            onClick={() => setShowForm(true)}
          >
            + Create
          </button>

          <table className="table table-bordered">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Number</th>
                <th>Slug</th>
                <th>Icon</th>
                <th>Heading</th>
                <th>Paragraph</th>
                <th>Image</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {data.map((item, index) => (
                <tr key={item._id}>
                  <td>{index + 1}</td>
                  <td>{item.number}</td>
                  <td>{item.slug}</td>
                  <td>{item.icon}</td>
                  <td>{item.heading}</td>
                  <td>{item.paragraph}</td>

                  <td>
                    <img
                      src={`${ENV_API_BASE_URL}/uploads/${item.image}`}
                      width="60"
                      alt=""
                    />
                  </td>

                  <td>
                    <button
                      className="btn btn-warning btn-sm me-2"
                      onClick={() => handleEdit(item)}
                    >
                      Edit
                    </button>

                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDelete(item._id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>

          </table>
        </>
      )}

      {showForm && (
      <form onSubmit={handleSubmit} className="card p-4">

<label>Number*</label>
<input
  type="text"
  name="number"
  className="form-control mb-2"
  value={formData.number}
  onChange={handleChange}
  placeholder="01"
  required
/>

<label>Slug*</label>
<input
  type="text"
  name="slug"
  className="form-control mb-2"
  value={formData.slug}
  onChange={handleChange}
  placeholder="100-hour-ttc"
/>

<label>Icon*</label>
<input
  type="text"
  name="icon"
  className="form-control mb-2"
  value={formData.icon}
  onChange={handleChange}
/>

<label>Heading*</label>
<input
  type="text"
  name="heading"
  className="form-control mb-2"
  value={formData.heading}
  onChange={handleChange}
/>

<label>Paragraph*</label>
<textarea
  name="paragraph"
  className="form-control mb-2"
  value={formData.paragraph}
  onChange={handleChange}
  rows="4"
/>

<label>Image*</label>
<input
  type="file"
  name="image"
  className="form-control mb-3"
  onChange={handleChange}
/>

{/* BENEFITS */}

<h5 className="mt-3">Benefits</h5>

{formData.benefits.map((item, index) => (
  <div key={index} className="border p-3 mb-3">

    <input
      type="text"
      placeholder="Icon"
      className="form-control mb-2"
      value={item.icon}
      onChange={(e) => {
        const updated = [...formData.benefits];
        updated[index].icon = e.target.value;
        setFormData({ ...formData, benefits: updated });
      }}
    />

    <input
      type="text"
      placeholder="Card Heading"
      className="form-control mb-2"
      value={item.cardHeading}
      onChange={(e) => {
        const updated = [...formData.benefits];
        updated[index].cardHeading = e.target.value;
        setFormData({ ...formData, benefits: updated });
      }}
    />

    <textarea
      placeholder="Card Paragraph"
      className="form-control mb-2"
      value={item.cardParagraph}
      onChange={(e) => {
        const updated = [...formData.benefits];
        updated[index].cardParagraph = e.target.value;
        setFormData({ ...formData, benefits: updated });
      }}
    />

    <button
      type="button"
      className="btn btn-danger btn-sm"
      onClick={() => {
        const updated = formData.benefits.filter((_, i) => i !== index);
        setFormData({ ...formData, benefits: updated });
      }}
    >
      Delete
    </button>

  </div>
))}

<button
  type="button"
  className="btn btn-primary btn-sm"
  onClick={() =>
    setFormData({
      ...formData,
      benefits: [
        ...formData.benefits,
        { icon: "", cardHeading: "", cardParagraph: "" }
      ]
    })
  }
>
  + Add Benefit
</button>

{/* TRADITIONAL */}

<h5 className="mt-4">Traditional</h5>

{formData.traditional.map((item, index) => (
  <div key={index} className="border p-3 mb-3">

    <input
      type="text"
      placeholder="Heading"
      className="form-control mb-2"
      value={item.heading}
      onChange={(e) => {
        const updated = [...formData.traditional];
        updated[index].heading = e.target.value;
        setFormData({ ...formData, traditional: updated });
      }}
    />

    <input
      type="text"
      placeholder="Number"
      className="form-control mb-2"
      value={item.number}
      onChange={(e) => {
        const updated = [...formData.traditional];
        updated[index].number = e.target.value;
        setFormData({ ...formData, traditional: updated });
      }}
    />

    <input
      type="text"
      placeholder="Title"
      className="form-control mb-2"
      value={item.title}
      onChange={(e) => {
        const updated = [...formData.traditional];
        updated[index].title = e.target.value;
        setFormData({ ...formData, traditional: updated });
      }}
    />

    <button
      type="button"
      className="btn btn-danger btn-sm"
      onClick={() => {
        const updated = formData.traditional.filter((_, i) => i !== index);
        setFormData({ ...formData, traditional: updated });
      }}
    >
      Delete
    </button>

  </div>
))}

<button
  type="button"
  className="btn btn-primary btn-sm"
  onClick={() =>
    setFormData({
      ...formData,
      traditional: [
        ...formData.traditional,
        { heading: "", number: "", title: "" }
      ]
    })
  }
>
  + Add Traditional
</button>

{/* PRACTICE */}

<h5 className="mt-4">Practice</h5>

{formData.practice.map((item, index) => (
  <div key={index} className="border p-3 mb-3">

    <input
      type="text"
      placeholder="Icon"
      className="form-control mb-2"
      value={item.cardicon}
      onChange={(e) => {
        const updated = [...formData.practice];
        updated[index].cardicon = e.target.value;
        setFormData({ ...formData, practice: updated });
      }}
    />

    <input
      type="text"
      placeholder="Heading"
      className="form-control mb-2"
      value={item.cardHead}
      onChange={(e) => {
        const updated = [...formData.practice];
        updated[index].cardHead = e.target.value;
        setFormData({ ...formData, practice: updated });
      }}
    />

    <textarea
      placeholder="Paragraph"
      className="form-control mb-2"
      value={item.cardPara}
      onChange={(e) => {
        const updated = [...formData.practice];
        updated[index].cardPara = e.target.value;
        setFormData({ ...formData, practice: updated });
      }}
    />

    <button
      type="button"
      className="btn btn-danger btn-sm"
      onClick={() => {
        const updated = formData.practice.filter((_, i) => i !== index);
        setFormData({ ...formData, practice: updated });
      }}
    >
      Delete
    </button>

  </div>
))}

<button
  type="button"
  className="btn btn-primary btn-sm"
  onClick={() =>
    setFormData({
      ...formData,
      practice: [
        ...formData.practice,
        { cardicon: "", cardHead: "", cardPara: "" }
      ]
    })
  }
>
  + Add Practice
</button>

<button className="btn btn-success">
  {editId ? "Update" : "Save"}
</button>

</form>
      )}

    </div>
  );
}

export default TeacherTrainingCards;